import urlConstants from './urlConstants.mjs';
import rewriteRoutes from './rewriteRoutes.mjs';
import redirectRoutes from './redirectRoutes.mjs';

export { urlConstants, rewriteRoutes, redirectRoutes };
export default urlConstants;
